export const TTL_LIST = [
    {
        value: 60,
        label: '1 min',
        alias: true,
    },
    {
        value: 300,
        label: '5 min',
        alias: true,
    },
    {
        value: 1200,
        label: '20 min',
    },
    {
        value: 1800,
        label: '30 min',
    },
    {
        value: 3600,
        label: '60 min',
    },
];

export const URL_REDIRECT = {
    FRAME: 'FRAME',
    URL: 'URL',
    URL301: 'URL301',
};

export const URL_REDIRECT_LIST = [
    {
        value: 'FRAME',
        label: 'Masked',
    },
    {
        value: 'URL',
        label: 'Unmasked',
    },
    {
        value: 'URL301',
        label: 'URL301',
    },
];

export const RECORD_TYPES = {
    A: 'A',
    AAAA: 'AAAA',
    ALIAS: 'ALIAS',
    CAA: 'CAA',
    CNAME: 'CNAME',
    NS: 'NS',
    TXT: 'TXT',
    REDIRECT: 'REDIRECT',
};

export const RECORD_TYPES_LIST = [
    {
        value: 'A',
        label: 'A Record',
    },
    {
        value: 'AAAA',
        label: 'AAAA Record',
    },
    {
        value: 'ALIAS',
        label: 'ALIAS Record',
    },
    {
        value: 'CAA',
        label: 'CAA Record',
    },
    {
        value: 'CNAME',
        label: 'CNAME Record',
    },
    {
        value: 'NS',
        label: 'NS Record',
    },
    {
        value: 'TXT',
        label: 'TXT Record',
    },
    {
        value: 'REDIRECT',
        label: 'URL Redirect Record',
    },
];

export const CCA_TYPES = {
    issue: 'issue',
    issuewild: 'issuewild',
    iodef: 'iodef',
};

export const MAIL_SETTING = {
    NONE: {
        value: 'NONE',
        label: 'No Email service',
    },
    MX: {
        value: 'MX',
        label: 'Custom MX',
    },
    MXE: {
        value: 'MXE',
        label: 'MXE Record',
    },
    GMAIL: {
        value: 'GMAIL',
        label: 'Gmail',
    },
    FWD: {
        value: 'FWD',
        label: 'Email Forwarding',
    },
};

export const EMAIL_FORWARDING_VALUE =
    'v=spf1 include:spf.efwd.registrar-servers.com ~all';

export const CATCH_ALL_VALUE = 'Catch-All';

export const DOMAIN_VALUE = '@';

export const NAMESERVER_OPTIONS = [
    'ns1',
    'ns2',
    'ns3',
    'ns4',
    'ns5',
    'ns6',
    'ns7',
    'ns8',
    'ns9',
    'dns1',
    'dns2',
    'dns3',
    'dns4',
    'dns5',
    'dns6',
    'dns7',
    'dns8',
    'dns9',
];

export const IGNORE_TLD = [];

export const COUNTRY_CODE_WITH_TLD = [
    {
        tld: 'eu',
        countryCode: [
            'AT',
            'BE',
            'BG',
            'HR',
            'CY',
            'CZ',
            'DK',
            'EE',
            'FI',
            'FR',
            'DE',
            'GR',
            'HU',
            'IE',
            'IT',
            'LV',
            'LT',
            'LU',
            'MT',
            'NL',
            'PL',
            'PT',
            'RO',
            'SK',
            'SI',
            'ES',
            'SE',
        ],
    },
];

export const NAMESERVER_OPTION = {
    CUSTOM: 'custom',
    OWNED_DNS: '1byte',
    WP_DNS: '1byte_wp',
};

export const DOMAIN_TRANSFER_ERROR_REASONS = {
    NOT_AVAILABLE: {
        key: 'NOT_AVAILABLE',
        title: 'domain.domain_transfer_error.not_available.title',
        description: 'domain.domain_transfer_error.not_available.description',
    },
    NOT_YET_PURCHASED: {
        key: 'NOT_YET_PURCHASED',
        title: 'domain.domain_transfer_error.not_yet_purchased.title',
        description:
            'domain.domain_transfer_error.not_yet_purchased.description',
    },
    ALREADY_EXISTS: {
        key: 'ALREADY_EXISTS',
        title: 'domain.domain_transfer_error.already_exists.title',
        description: 'domain.domain_transfer_error.already_exists.description',
    },
};
